<template>
  <no-ssr>
    <nuxt />
  </no-ssr>
</template>

<script>
  export default {
    created() {
    },
    data() {
        return {}
    },
    mounted() {
    },
    computed: {},
    methods: {},
    destroyed() {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// layouts/default.vue